import React, { useState, useEffect, useContext, useRef } from "react";
import { useDispatch } from "react-redux";
import { Redirect, useParams } from "react-router-dom";
import { useHistory, useLocation } from 'react-router';
import axios from "axios";
import moment from "moment";
import html2canvas from "html2canvas";

import { Card, CardBody, Layout, Menu, Row, Col, Button, Space, message, Empty, Spin, Tag } from "antd";
import { LeftOutlined, RightOutlined, NodeIndexOutlined, RiseOutlined, DashboardOutlined, ThunderboltOutlined, HeartOutlined, CompassOutlined, StarOutlined, ClockCircleOutlined, FieldTimeOutlined, SoundOutlined, SaveOutlined } from "@ant-design/icons";

import { setBreadcrumb } from "redux/actions/app.action";
import generalService from "services/general.service";
import generalHelper from "helper/general.helper";
import ActivityService from "services/activity.service";

import Header from "components/shared/Header";
import Filter from "components/overview/Filter";
import DataTable from "components/overview/DataTable";
import BarChart from "components/shared/BarChart";

import emptyImg from "assets/img/empty.svg";
import RunIcon from "assets/icon/RunIcon";
import RideIcon from "assets/icon/RideIcon";
import SwimIcon from "assets/icon/SwimIcon";
import HikeIcon from "assets/icon/HikeIcon";
import WalkIcon from "assets/icon/WalkIcon";
import BadmintonIcon from "assets/icon/BadmintonIcon";
import PickleballIcon from "assets/icon/PickleballIcon";
import TennisIcon from "assets/icon/TennisIcon";
import TableTennisIcon from "assets/icon/TableTennisIcon";
import YogaIcon from "assets/icon/YogaIcon";
import WorkoutIcon from "assets/icon/WorkoutIcon";
import BlobIcon from "assets/icon/BlobIcon";
import YearInSportEmblem from "assets/icon/YearInSportEmblem";
import YearInSportBadge from "assets/icon/YearInSportBadge";
import BackgroundMusic from "assets/music/background.mp3";

import useSound from "use-sound";
import { isSafari } from "react-device-detect";

import { SocketContext } from "contexts/SocketContext";
import { AppContext } from "contexts/AppContext";

import {
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
  STATS_TYPE,
  WS_URL,
  TOKEN_NAME,
  VIEW_TYPE,
  SPORT_ICONS,
  CHART_COLOR_OPTION
} from "constants/index";

import AuthorizedFunction from "config/AuthorizedFunction";

const YearInSport = (data) => {
  // const socket = useContext(SocketContext);
  // const [wsMessage, setWSMessage] = useState("");
  const appContext = useContext(AppContext);
  const location = useLocation();
  const { athlete_id } = useParams();
  const { year } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [athlete, setAthlete] = useState(null);
  const [yearInSport, setYearInSport] = useState(null);
  const [pastYearInSport, setPastYearInSport] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [play, {stop, pause}] = useSound(BackgroundMusic, {
    onplay: () => setIsPlaying(true),
    onend: () => setIsPlaying(false),
  });
  const pageRef = React.useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      id: athlete_id,
      year: year ? year : moment().startOf("year").format(DATE_TIME_FORMAT.YEAR),
    }

    if (!appContext.selectedAthlete) {
      const searchParams = new URLSearchParams(location.search);
      if (searchParams) {
        appContext.setDateRange({ startDate: moment(searchParams.get("start")), endDate: moment(searchParams.get("end"))});
        appContext.setSportView(searchParams.get("sport"));
        appContext.setPageView(searchParams.get("view"));
      }
    }
    
    fetchData(params);
  }, [data, appContext.sportView]);

  const fetchData = (params) => {
    setIsLoading(true);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    ActivityService.getYearInSport(params, source).then(
      (request) => {
        setYearInSport(request.yearInSport);
        setPastYearInSport(request.pastYearInSport);
        setAthlete(request.athlete);
        // if (request.athlete?.avatar) {
        //   convertImageToBase64(request.athlete.avatar)
        //     .then(setAvatarBase64);
        // }
        setTimeout(() => {
          setIsLoading(false);
        }, 400);
      },
      (error) => {
        if (error && error.response.data && error.response.data.errors) {
          message.error(error.response.data.errors.join(". "), 5);
        } else if (error && error.message !== CANCEL_REQUEST) {
          message.error("API got error, please contact us.", 5);
        }
        console.log(error);
        setIsLoading(false);
        return Promise.reject();
      }
    );
  };

  const handlePlay = () => {
    if (isSafari && !isPlaying) {
      play();
    }
  }

  const convertImageToBase64 = async (url) => {
    try {
      debugger;
      const response = await fetch(url, {
        mode: "cors",
      });

      const blob = await response.blob();

      return await new Promise((resolve) => {
        const reader = new FileReader();

        reader.onloadend = () => resolve(reader.result);

        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const saveToGallery = async () => {
    const element = document.getElementById("year-in-sport");

    const canvas = await html2canvas(element, {
      scale: 3, // nét hơn trên mobile
      useCORS: true,
    });

    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `year-in-sport-${year}.png`;
      a.click();

      URL.revokeObjectURL(url);
    });
  };

  const exportStoryImage = async () => {
    try {
      const STORY_WIDTH = 1080;
      const STORY_HEIGHT = 1920;
      const target = document.getElementById("year-in-sport");

      document.body.classList.add("capturing");

      await new Promise((r) => requestAnimationFrame(r));

      // capture original DOM in high resolution
      const captureCanvas = await html2canvas(target, {
        backgroundColor: null,
        useCORS: true,
        allowTaint: true,

        // important
        scale: 3,

        logging: false,
        imageTimeout: 0,

        scrollX: 0,
        scrollY: -window.scrollY,

        width: target.scrollWidth,
        height: target.scrollHeight,

        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
      });

      // create final export canvas
      const exportCanvas = document.createElement("canvas");

      exportCanvas.width = STORY_WIDTH;
      exportCanvas.height = STORY_HEIGHT;

      const ctx = exportCanvas.getContext("2d");

      // high quality scaling
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";

      // background
      ctx.fillStyle = "#f5f5f5";
      ctx.fillRect(0, 0, STORY_WIDTH, STORY_HEIGHT);

      // keep aspect ratio
      const scale = Math.min(
        STORY_WIDTH / captureCanvas.width,
        STORY_HEIGHT / captureCanvas.height
      );

      const drawWidth = captureCanvas.width * scale;
      const drawHeight = captureCanvas.height * scale;

      const x = (STORY_WIDTH - drawWidth) / 2;
      const y = (STORY_HEIGHT - drawHeight) / 2;

      ctx.drawImage(
        captureCanvas,
        x,
        y,
        drawWidth,
        drawHeight
      );

      document.body.classList.remove("capturing");

      // export PNG FULL QUALITY
      exportCanvas.toBlob(
        async (blob) => {
          if (!blob) return;

          const file = new File(
            [blob],
            "stravamate-story.png",
            {
              type: "image/png",
            }
          );

          // MOBILE SHARE
          if (
            navigator.canShare &&
            navigator.canShare({ files: [file] })
          ) {
            await navigator.share({
              files: [file],
              title: "Year In Sport",
            });

            return;
          }

          // fallback download
          const url = URL.createObjectURL(blob);

          const a = document.createElement("a");

          a.href = url;
          a.download = "stravamate-story.png";

          document.body.appendChild(a);

          a.click();

          a.remove();

          URL.revokeObjectURL(url);
        },
        "image/png",
        1.0
      );
    } catch (err) {
      document.body.classList.remove("capturing");
      console.error(err);
    }
  }

  const TopSport = (data) => {
    if (data.sport === "Run") {
      return (
        <p>
          <RunIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span className={yearInSport.run_ranking > 0 ? `rank topsport rank-${yearInSport.run_ranking}` : ""}></span>
            <h6>{generalHelper.formatDistance(data.total_distance, 0, true)}</h6>
            <span className="max-distance">{generalHelper.formatDistance(data.max_distance, 0, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "Ride") {
      return (
        <p>
          <RideIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span className={yearInSport.ride_ranking > 0 ? `rank topsport rank-${yearInSport.ride_ranking}` : ""}></span>
            <h6>{generalHelper.formatDistance(data.total_distance, 0, true)}</h6>
            <span className="max-distance">{generalHelper.formatDistance(data.max_distance, 0, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "Swim") {
      return (
        <p>
          <SwimIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span className={yearInSport.swim_ranking > 0 ? `rank topsport rank-${yearInSport.swim_ranking}` : ""}></span>
            <h6>{generalHelper.formatDistance(data.total_distance, 0, true)}</h6>
            <span className="max-distance">{generalHelper.formatDistance(data.max_distance, 0, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "Hike") {
      return (
        <p>
          <HikeIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span className={yearInSport.hike_ranking > 0 ? `rank topsport rank-${yearInSport.hike_ranking}` : ""}></span>
            <h6>{generalHelper.formatDistance(data.total_distance, 0, true)}</h6>
            <span className="max-distance">{generalHelper.formatDistance(data.max_distance, 0, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "Badminton") {
      return (
        <p>
          <BadmintonIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span></span>
            <h6>{generalHelper.formatDisplayTime(data.total_moving_time, true, true)}</h6>
            <span className="max-distance">{generalHelper.formatDisplayTime(data.max_moving_time, true, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "Pickleball") {
      return (
        <p>
          <PickleballIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span></span>
            <h6>{generalHelper.formatDisplayTime(data.total_moving_time, true, true)}</h6>
            <span className="max-distance">{generalHelper.formatDisplayTime(data.max_moving_time, true, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "Tennis") {
      return (
        <p>
          <TennisIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span></span>
            <h6>{generalHelper.formatDisplayTime(data.total_moving_time, true, true)}</h6>
            <span className="max-distance">{generalHelper.formatDisplayTime(data.max_moving_time, true, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "TableTennis") {
      return (
        <p>
          <TableTennisIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span></span>
            <h6>{generalHelper.formatDisplayTime(data.total_moving_time, true, true)}</h6>
            <span className="max-distance">{generalHelper.formatDisplayTime(data.max_moving_time, true, true)}</span>
          </div>
        </p>
      );
    } else if (data.sport === "Yoga") {
      return (
        <p>
          <YogaIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span></span>
            <h6>{generalHelper.formatDisplayTime(data.total_moving_time, true, true)}</h6>
            <span className="max-distance">{generalHelper.formatDisplayTime(data.max_moving_time, true, true)}</span>
          </div>
        </p>
      );
    } else {
      return (
        <p>
          <WorkoutIcon/> {generalHelper.formatDisplayNumber(data.count, 0)}
          <div>
            <span></span>
            <h6>{generalHelper.formatDisplayTime(data.total_moving_time, true, true)}</h6>
            <span className="max-distance">{generalHelper.formatDisplayTime(data.max_moving_time, true, true)}</span>
          </div>
        </p>
      );
    }
  }

  return (
    <>
      <button className="btn-icon btn-share" onClick={saveToGallery}>
        <span><SaveOutlined/></span>
      </button>
      <div ref={pageRef} id="year-in-sport" className="year-in-sport" onClick={handlePlay}>
        {!isLoading ? (
        <>
          { !isSafari &&
            <audio id="audio" preload="auto" loop autoPlay> 
              <source src={BackgroundMusic} type="audio/mpeg" />
            </audio>
          }

          { yearInSport &&
            <div className="summary-panel">
              <div className="blobs">
                <BlobIcon startColor="#F7971E" stopColor="#FFD200" />
                <BlobIcon startColor="#FFC371" stopColor="#FC00FF" />
                <BlobIcon startColor="#FEE140" stopColor="#FA709A" />
                <BlobIcon startColor="#85FFBD" stopColor="#FFFB7D" />
              </div>

              <div className="badge-container">
                <div className="badge">
                  <YearInSportBadge width="120" height="120" />
                  {/* <YearInSportEmblem width="180" height="180" /> */}
                  <div className="badge-content">
                    <div className="brand">STRAVAMATE</div>
                    <div className="title">YEAR IN</div>
                    <div className="main">SPORT</div>
                    <div className="year">{year}</div>
                  </div>
                </div>
              </div>

              {/* <h1>YEAR IN SPORT</h1>
              <h2 className="rainbow-letters">{[...year].map(char => {
                return <span>{char}</span>
              })}</h2> */}
              <div className="user-avatar">
                <img src={athlete.avatar} />
                <span>{athlete.name}</span>
              </div>

              <div className="stats-summary w100">
                <h4>Total Time <div className={yearInSport.time_ranking > 0 ? `rank overall rank-${yearInSport.time_ranking}` : ""}></div></h4>
                <h5>
                  {generalHelper.formatDisplayTime(yearInSport.total_moving_time, true)}
                  {generalHelper.calculateImprovement(yearInSport.total_moving_time, pastYearInSport.total_moving_time)}
                </h5>
                <h6>Hours</h6>
              </div>

              <div className="stats-summary w-chart">
                <h4>Total Distance <div className={yearInSport.distance_ranking > 0 ? `rank overall rank-${yearInSport.distance_ranking}` : ""}></div></h4>
                <h5>
                  {generalHelper.formatDistance(yearInSport.total_distance, 0, false)}
                  {generalHelper.calculateImprovement(yearInSport.total_distance, pastYearInSport.total_distance)}
                </h5>
                <h6>Kilometers</h6>
                { yearInSport.chartData &&
                  <BarChart
                    chartTitle={"Distance"}
                    chartData={yearInSport.chartData}
                    chartKeyData={"distance"}
                    chartColor={CHART_COLOR_OPTION.Distance}
                    chartHeight={"10vh"}
                    pageView={VIEW_TYPE.Year}
                  />
                }
              </div>

              { yearInSport.total_calories > 0 ?
                <div className="stats-summary fixed">
                  <h4>Burned</h4>
                  <h5>
                    {generalHelper.formatDisplayNumber(yearInSport.total_calories, 0)}
                    {generalHelper.calculateImprovement(yearInSport.total_calories, pastYearInSport.total_calories)}
                  </h5>
                  <h6>Calories</h6>
                  { yearInSport.chartData &&
                    <BarChart
                      chartTitle={"Calories"}
                      chartData={yearInSport.chartData}
                      chartKeyData={"calories"}
                      chartColor={CHART_COLOR_OPTION.Calories}
                      chartHeight={"10vh"}
                      pageView={VIEW_TYPE.Year}
                    />
                  }
                </div> :
                <div className="stats-summary fixed">
                  <h4>&nbsp;</h4>
                  <h5>&nbsp;</h5>
                  <h6>&nbsp;</h6>
                </div>
              }

              <div className="stats-summary w-chart">
                <h4>Total Elevation <div className={yearInSport.elevation_ranking > 0 ? `rank overall rank-${yearInSport.elevation_ranking}` : ""}></div></h4>
                <h5>
                  {generalHelper.formatDisplayNumber(yearInSport.total_elevation_gain, 0, STATS_TYPE.Elevation, false, false, false)}
                  {generalHelper.calculateImprovement(yearInSport.total_elevation_gain, pastYearInSport.total_elevation_gain)}
                  </h5>
                <h6>Meters</h6>
                { yearInSport.chartData &&
                  <BarChart
                    chartTitle={"Elevation"}
                    chartData={yearInSport.chartData}
                    chartKeyData={"elevation"}
                    chartColor={CHART_COLOR_OPTION.Elevation}
                    chartHeight={"10vh"}
                    pageView={VIEW_TYPE.Year}
                  />
                }
              </div>

              <div className="stats-summary w-chart fixed">
                <h4>Days Active</h4>
                <h5>
                  {generalHelper.formatDisplayNumber(yearInSport.total_days, 0)}
                  {generalHelper.calculateImprovement(yearInSport.total_days, pastYearInSport.total_days)}
                </h5>
                <h6>Days</h6>
                { yearInSport.chartData &&
                  <BarChart
                    chartTitle={"Days Active"}
                    chartData={yearInSport.chartData}
                    chartKeyData={"total_days"}
                    chartColor={CHART_COLOR_OPTION.DaysActive}
                    chartHeight={"10vh"}
                    pageView={VIEW_TYPE.Year}
                  />
                }
              </div>

              <div className="stats-summary top-sports">
                <h4>Top Sports</h4>
                <h5>
                  {yearInSport.top_sports && yearInSport.top_sports.length > 0 && yearInSport.top_sports.map((s) => TopSport(s))}
                </h5>
              </div>
              {/* <h3><span>#</span>stravamate</h3> */}
            </div>
          }
        </>) :
        (
          <Empty image={emptyImg} imageStyle={{height: 60}} description={<span>Loading..</span>}>
            <Spin />
          </Empty>
        )}
      </div>
    </>
  );
};

export default YearInSport;
